import { Work } from '../components';

const Seance = () => {
   return <Work />;
};
export default Seance;
